import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Board } from 'src/app/core/models/board.model';
import { BoardGameMeter } from 'src/app/core/models/boardGameMeter.model';
import { BoardRead } from 'src/app/core/models/boardRead.model';
import { BoardStats } from 'src/app/core/models/boardStats.model';
import { Game } from 'src/app/core/models/game.model';
import { User } from 'src/app/core/models/user.model';
import { BoardService } from 'src/app/core/services/board.service';
import { BoardGameMeterService } from 'src/app/core/services/boardGameMeter.service';
import { boardReadService } from 'src/app/core/services/boardRead.service';
import { GameService } from 'src/app/core/services/game.service';
import { LocationService } from 'src/app/core/services/location.service';
import { LoginService } from 'src/app/core/services/login.service';
import { BoardStatsByIdComponent } from 'src/app/pages/boardStatsById/boardStatsById.component';
import { Location as AppLocation } from 'src/app/core/models//location.model'; // adjust path as needed


@Component({
  selector: 'app-boardRead',
  templateUrl: './boardRead.component.html',
  styleUrls: ['./boardRead.component.scss'],
  providers: [DatePipe]
})

/**
 * Dashboard Component
 */
export class BoardReadComponent implements OnInit {
  @ViewChild('gameMetersModal') gameMetersModal!: TemplateRef<any>; // <-- ADD HERE
  selectedBoardItem: BoardRead | null = null; // <-- AND HERE

  term: any;
  boardRead: BoardRead[] = [];
  board: Board[] = [];
  boardStats: BoardStats[] = [];
  filteredReads: BoardRead[] = [];
  filteredPagenatedReads: BoardRead[] = [];
  boardGameMeters: { [key: string]: BoardGameMeter[] } = {};
  loadingMeters: { [key: string]: boolean } = {};
  expandedBoardReadId: string | null = null;
  currentUser: User | null = null;
  readonly defaultMonths = 6;
  monthsLoaded = this.defaultMonths;

  selectedLocationId: string | null = null;
  selectedGamePackageId: string | null = null;
  selectedBoardReadId: string | null = null;

  allLocations: AppLocation[] = [];
  allGamePackages: Game[] = [];



  pageSize = 50;
  pageNumber = 0;
  numberOfPages = 0;

  isLoading = false;
  private searchTimer: any;

  tastr: any;

  constructor(private boardService: BoardService, private boardReadService: boardReadService, 
    private modalService: NgbModal, private datePipe: DatePipe, 
    private boardGameMeterService: BoardGameMeterService, public loginService: LoginService,
    private locationService: LocationService, private gamePackageService: GameService) {
  }

  // bread crumb items
  breadCrumbItems: Array<{}> = [];
  @ViewChild('updateBoardReadModal', { static: true }) updateBoardReadModal!: TemplateRef<any>;


async ngOnInit(): Promise<void> {
  this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Board Reads', active: true }];

  this.allLocations = await this.locationService.getAll();
  this.allGamePackages = await this.gamePackageService.getAll();

  await this.refresh();
}


  private shiftMonths(base: Date, deltaMonths: number): Date {
    const copy = new Date(base);
    copy.setHours(0, 0, 0, 0);
    const day = copy.getDate();
    copy.setMonth(copy.getMonth() + deltaMonths, 1);
    const lastDay = new Date(copy.getFullYear(), copy.getMonth() + 1, 0).getDate();
    copy.setDate(Math.min(day, lastDay));
    return copy;
  }

  private getCutoffDate(): Date {
    const today = new Date();
    return this.shiftMonths(today, -this.monthsLoaded);
  }

  async refresh(forceRefresh = false) {
    this.isLoading = true;
    const cutoff = this.getCutoffDate();
    const cutoffTs = cutoff.getTime();

    const allBoardReads = await this.boardReadService.getAll({
      cutoffDate: cutoff,
      forceRefresh
    });

    this.boardRead = allBoardReads
      .filter(item => item.cashIn > -1)
      .filter(item => {
        const ts = Date.parse(item?.timeStamp || '');
        return Number.isFinite(ts) ? ts >= cutoffTs : true;
      });

    this.pageNumber = 0;
    this.updateFilteredReads();
    this.isLoading = false;
  }

  async loadMoreMonths(): Promise<void> {
    this.monthsLoaded += this.defaultMonths;
    await this.refresh(true);
  }

  getBoardtStatsLink(item: BoardStats): String {
    return "";
  }


  async downloadCsv() {
    const downloadResult = await this.boardReadService.download();
    const a = document.createElement('a');
    a.download = downloadResult.fileName;
    a.href = window.URL.createObjectURL(new Blob([downloadResult.file], {type: "text/csv"}));
    a.click();
    window.URL.revokeObjectURL(a.href);
    await this.refresh();
    this.tastr.error('downloaded');


    }

    onSearch() {
      const termLower = (this.term || '').toLowerCase().trim();
      this.updateFilteredReads(termLower);
    }

    onSearchDebounced(term: string) {
      this.term = term;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(() => this.onSearch(), 200);
    }
    

    updateFilteredReads(filter: any = null) {
      if(filter){
      this.filteredReads = this.boardRead.filter(boardRead =>
        (this.datePipe.transform(boardRead.timeStamp)?.toLowerCase().includes(filter)) ||
        (boardRead.board?.serialNumber?.toLowerCase().includes(filter)) ||
        (boardRead.board?.assetTag?.toLowerCase().includes(filter)) ||
        ((boardRead.salesRepFirstNameSnapshot || boardRead.deployment?.location?.salesRep?.firstName || '').toLowerCase().includes(filter)) ||
        ((boardRead.salesRepLastNameSnapshot || boardRead.deployment?.location?.salesRep?.lastName || '').toLowerCase().includes(filter)) ||
        ((boardRead.gameNameSnapshot || boardRead.deployment?.installedGamePackage?.name || '').toLowerCase().includes(filter)) ||
        ((boardRead.gameVersionSnapshot || boardRead.deployment?.installedGamePackage?.version || '').toLowerCase().includes(filter))
      );

        // console.log('Filtered Reads:', this.filteredReads);  // Log to check filtered results
      } else {
        this.filteredReads =  this.boardRead;
      }

      this.numberOfPages = Math.ceil(this.filteredReads.length/this.pageSize)
      this.updatePagination();
    }

    updatePagination() {
      const pageStart = this.pageSize * this.pageNumber;
      const pageStop = Math.min(pageStart + this.pageSize, this.filteredReads.length);
      this.filteredPagenatedReads = this.filteredReads.slice(pageStart, pageStop);
    }

    trackByRead = (_: number, item: any) => item?.id || item;
    trackByMeter = (_: number, meter: any) => meter?.id || meter?.game?.id || meter;
    trackByLocation = (_: number, loc: any) => loc?.id || loc?.locationTag || loc;
    trackByGame = (_: number, game: any) => game?.id || game?.name || game;

    canDecrement() {
      return this.pageNumber > 0;
    }

    decrementPage() {
      if (this.pageNumber > 0) {
        this.pageNumber--;
      }
      this.updateFilteredReads();
    }

    canIncrement() {
      return this.pageNumber < this.numberOfPages -1;
    }

    incrementPage() {
      if (this.pageNumber < this.numberOfPages -1) {
        this.pageNumber++;
      }
       this.updateFilteredReads();
    }

    openBoardStatsModal(assetTag: string): void {
      const modalRef = this.modalService.open(BoardStatsByIdComponent, {
        size: 'lg', // or 'sm' depending on your design
      });
  
      modalRef.componentInstance.assetTag = assetTag;  // Pass the assetTag to the modal component
    }

    openGameMetersModal(item: BoardRead): void {
      const boardReadId = item.id;
    
      this.selectedBoardItem = item;
    
      if (!this.boardGameMeters[boardReadId]) {
        this.loadingMeters[boardReadId] = true;
        this.boardGameMeterService.getByBoardReadId(boardReadId).then((data) => {
          this.boardGameMeters[boardReadId] = data;
          this.loadingMeters[boardReadId] = false;
    
          // Open modal after data is loaded
          this.modalService.open(this.gameMetersModal, {
            size: 'xl',
            backdrop: 'static',
            centered: true
          });
        }).catch((error) => {
          console.error('Error loading meters:', error);
          this.loadingMeters[boardReadId] = false;
        });
      } else {
        this.modalService.open(this.gameMetersModal, {
          size: 'xl',
          backdrop: 'static',
          centered: true
        });
      }
    }

    async createStatsForBoardRead(item: any): Promise<void> {
  if (!item?.id) {
    console.error("Missing boardReadId");
    return;
  }

  try {
    const result = await this.boardReadService.updateStatsForBoardRead(item.id);
    if (result) {
      console.log("Stats created:", result);
      this.refresh(); // ✅ refresh list after update
    }
  } catch (err) {
    console.error("Failed to create stats:", err);
  }
}

    updateBoardReadSelection(): void {
      // ✅ Ensure a BoardRead is selected before proceeding
      if (!this.selectedBoardReadId) return;

      // ✅ Build the update payload with optional fields
      const payload: Partial<BoardRead> = {};

      if (this.selectedLocationId) {
        payload.location = { id: this.selectedLocationId } as AppLocation;
      }

      if (this.selectedGamePackageId) {
        payload.installedGamePackage = { id: this.selectedGamePackageId } as Game;
      }

      // ✅ Call the service method to update the BoardRead
      this.boardReadService.updateBoardRead(this.selectedBoardReadId, payload)
        .then(() => {
          alert("✅ BoardRead updated successfully.");
          this.refresh(); // Refresh list after update
        })
        .catch(() => {
          alert("❌ Failed to update BoardRead. Please try again.");
        });
    }

    openUpdateModal(item: BoardRead): void {
  this.selectedBoardItem = item;
  this.selectedBoardReadId = item.id;
  this.selectedLocationId = item.board?.location?.id || null;
  this.selectedGamePackageId = item.board?.installedGamePackage?.id || null;

  this.modalService.open(this.updateBoardReadModal, {
    size: 'lg',
    backdrop: 'static',
    centered: true
  });
}



    
    
}
